import { Dropdown } from "primereact/dropdown";
import { inject, observer } from "mobx-react";

import { computed } from "mobx";

import "./style.scss";

const SelectSuggestUI = inject("mainStore")(
    observer(
        ({
            mainStore,
            value,
            dataKey,
            onChange,
            options = [],
            dataId = [],
            keyId,
            label,
            copied = false,
            isDisabled = false,
            addClass = "",
            filter = true,
            filterBy = "",
            showClear = true,
            placeholder = "Выберите из списка",
            optionValue,
            optionLabel = "code",
            selectedItemKey = "code",
            fetchOnClick = false,
            appendTo = document.body,
            required = false,
            onDropdownClick = () => {},
            changeableData,
            filterFunction = () => {},
            valueTemplate,
            itemTemplate,
        }) => {
            const dataOptions = computed(() => mainStore.getMainStore(dataKey)).get();

            let optionsSuggest = options.length > 0 ? options : dataOptions ? dataOptions : [];
            const selectedItem = optionsSuggest.find((f) => f[selectedItemKey] === value);
            const tooltip = selectedItem ? selectedItem.name : "";

            const handleCopy = () => {
                const selected = optionsSuggest.find((f) => f._id === value);
                if (selected?.title) {
                    navigator.clipboard.writeText(selected.title);
                }
            };

            return (
                <div className={`detail__item selectSuggest-ui ${addClass}`}>
                    {label ? (
                        <div className="selectSuggest-ui__container">
                            <label className={dataId.join("-")} htmlFor={keyId} data-pr-tooltip={label}>
                                {label}
                                {required ? "*" : ""}
                            </label>
                            {copied && <i onClick={handleCopy} className="pi pi-copy" />}
                        </div>
                    ) : null}
                    <Dropdown
                        id={keyId}
                        filter={filter}
                        filterBy={filterBy}
                        disabled={isDisabled}
                        showClear={showClear}
                        value={value}
                        onChange={(e) => onChange(e, dataId.join("."))}
                        onShow={fetchOnClick ? onDropdownClick : () => {}}
                        options={optionsSuggest}
                        optionValue={optionValue}
                        optionLabel={optionLabel}
                        placeholder={placeholder}
                        emptyFilterMessage="Нет элементов для выбора"
                        emptyMessage="Нет элементов для выбора"
                        data-id={dataId.join(".")}
                        className="detail__item_dropdown"
                        appendTo={appendTo}
                        tooltip={tooltip}
                        virtualScrollerOptions={{ itemSize: 44 }}
                        itemTemplate={itemTemplate}
                        valueTemplate={valueTemplate}
                    />
                </div>
            );
        },
    ),
);

export default SelectSuggestUI;
